import * as api from "@nens/threedi/openapi-client";

import { AppState, Thunk } from "../App";

import { BACK_TO_START_SCREEN, BackToStartScreen } from "./appState";
import { getExistingLeveeEdits } from "./existingEvents";

interface ExistingEdits {
  selected: api.ObstacleEdit | null;
}

const INITIAL_STATE: ExistingEdits = {
  selected: null,
};

export const getSelected = (state: AppState) => state.existingLeveeEdits.selected;

const SET_SELECTED = "existingLeveeEdits/SET_SELECTED";
const REMOVE_SELECTED = "existingLeveeEdits/REMOVE";

interface SetSelected {
  type: typeof SET_SELECTED;
  edit: api.ObstacleEdit | null;
}
interface RemoveSelected {
  type: typeof REMOVE_SELECTED;
}

export const setSelected =
  (selectedUid: string | null): Thunk =>
  (dispatch, getState) => {
    const existingEdits = getExistingLeveeEdits(getState());
    if (!existingEdits) return;

    const edit = existingEdits.find((edit) => edit.uid === selectedUid);

    dispatch({
      type: SET_SELECTED,
      edit: edit || null,
    });
  };
export const removeSelected = () => {
  return {
    type: REMOVE_SELECTED,
  };
};

type ExistingRasterEditAction = SetSelected | RemoveSelected | BackToStartScreen;

export default function reducer(state = INITIAL_STATE, action: ExistingRasterEditAction) {
  switch (action.type) {
    case BACK_TO_START_SCREEN:
      return INITIAL_STATE;
    case SET_SELECTED:
      return {
        selected: action.edit,
      };
    case REMOVE_SELECTED:
      return {
        selected: null,
      };
    default:
      return state;
  }
}
